const config = {
  API_URL: 'https://api.cybervibes.org',
};

export default config;
